export default "__VITE_ASSET__CDZON4Wa__"